module.exports = __webpack_public_path__ + "img/chrome.b596298.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/browsers/chrome.png
// module id = 9dnD
// module chunks = 38 43